import { useQuery } from "react-query"
import { getUserCountReportData } from "./api"

export const useUserCountReportData = () => {
  return useQuery({
    queryKey: ['userCountReportData'],
    queryFn: getUserCountReportData
  })
}
